/* ---------------------------------------------------------------------
 *                           Import Packages
 * --------------------------------------------------------------------- */

// React
import React, { useState } from "react";

// Images
import logo from "../../assets/images/logo1.png";
import qrcode from "../../assets/images/qrcode1.png";
import wechatIcon from "../../assets/images/wechat.png";

// MUI
import {
  Box,
  AppBar,
  Select,
  Avatar,
  Toolbar,
  Tooltip,
  Button,
  MenuItem,
  Typography,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

/* ---------------------------------------------------------------------
 *                            TopBar Component
 * --------------------------------------------------------------------- */

/**
 * 定义顶栏组件
 * @param {function} param.onOpenLogoutDialog - 打开退出登录对话框
 * @returns 顶栏组件
 * @function TopBar
 */
export default function TopBar({ onOpenLogoutDialog }) {
  /* ---------------------------------------------------------------------
   *                            Render Component
   * --------------------------------------------------------------------- */
  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        padding: "4px",
        backgroundColor: "#fff",
        borderBottom: "none",
      }}
    >
      <Toolbar
        sx={{ justifyContent: "space-between", minHeight: "64px !important" }}
      >
        {/* 左侧 Logo 和标题 */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Avatar src={logo} sx={{ width: 48, height: 48, mr: 1 }} />
          <Typography
            noWrap
            variant="h6"
            color="inherit"
            paddingLeft="5px"
            sx={{ color: "#333", fontSize: "18px", fontWeight: "600" }}
          >
            四加 —— AI跨境运营先驱者
          </Typography>
        </Box>

        {/* 右侧操作区 */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Select
            defaultValue=""
            displayEmpty
            size="small"
            variant="outlined"
            sx={{
              minWidth: 250,
              height: 36,
              backgroundColor: "#f5f5f5",
              fontSize: "15px",
            }}
          >
            <MenuItem value="">添加店铺</MenuItem>
          </Select>

          {/* 人工运营协助 */}
          <Tooltip
            title={
              <img
                src={qrcode}
                alt="二维码"
                style={{ width: 130, height: 130, display: "block" }}
              />
            }
            placement="bottom"
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <Avatar
                src={wechatIcon}
                alt="wechat"
                style={{ width: 60, height: 60, marginBottom: 3 }}
              />
              <Typography
                variant="body2"
                sx={{ color: "#222", fontSize: "12px", fontWeight: 600 }}
              >
                人工运营协助
              </Typography>
            </Box>
          </Tooltip>

          {/* 退出登录区域 */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <PersonOutlineIcon sx={{ fontSize: 48, color: "#333" }} />
            <Button
              color="inherit"
              onClick={onOpenLogoutDialog}
              sx={{ minWidth: "auto", padding: 0 }}
            >
              <Typography
                variant="body2"
                sx={{ fontSize: "14px", color: "#333", fontWeight: "600" }}
              >
                退出
              </Typography>
            </Button>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
